import { JSX } from "@caspio/components";
import { memo } from "react";
import { createReactComponent } from "./utils/createComponent";

export const Button = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasButton, HTMLCasButtonElement>("cas-button")
);
export const Checkbox = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasCheckbox, HTMLCasCheckboxElement>("cas-checkbox")
);
export const RadioButton = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasRadioButton, HTMLCasRadioButtonElement>(
    "cas-radio-button"
  )
);
export const RadioButtonGroup = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasRadioButtonGroup, HTMLCasRadioButtonGroupElement>(
    "cas-radio-button-group"
  )
);

//#region Grid Components

export const Grid = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasGrid, HTMLCasGridElement>("cas-grid")
);

export const GridColumn = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasGridColumn, HTMLCasGridColumnElement>(
    "cas-grid-column"
  )
);

export const GridColumnGroup = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasGridColumnGroup, HTMLCasGridColumnGroupElement>(
    "cas-grid-column-group"
  )
);

export const GridActionsCellRenderer = /*@__PURE__*/ memo(
  createReactComponent<
    JSX.CasActionsCellRenderer,
    HTMLCasActionsCellRendererElement
  >("cas-actions-cell-renderer")
);

export const GridDateAuthorCellRenderer = /*@__PURE__*/ memo(
  createReactComponent<
    JSX.CasDateAuthorCellRenderer,
    HTMLCasDateAuthorCellRendererElement
  >("cas-date-author-cell-renderer")
);

export const GridCellRendererSelector = /*@__PURE__*/ memo(
  createReactComponent<
    JSX.CasCellRendererSelector,
    HTMLCasCellRendererSelectorElement
  >("cas-cell-renderer-selector")
);

export const Icon = /*@__PURE__*/ memo(
  memo(createReactComponent<JSX.CasIcon, HTMLCasIconElement>("cas-icon"))
);
export const Image = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasImg, HTMLCasImgElement>("cas-img")
);
export const Input = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasInput, HTMLCasInputElement>("cas-input")
);

export const Loading = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasLoading, HTMLCasLoadingElement>("cas-loading")
);
export const NotificationFactory = /*@__PURE__*/ memo(
  createReactComponent<
    JSX.CasNotificationFactory,
    HTMLCasNotificationFactoryElement
  >("cas-notification-factory")
);
export const Menu = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasMenu, HTMLCasModalElement>("cas-menu")
);
export const MenuItem = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasMenuItem, HTMLCasModalElement>("cas-menu-item")
);
export const MenuTrigger = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasMenuTrigger, HTMLCasModalElement>(
    "cas-menu-trigger"
  )
);
export const Modal = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasModal, HTMLCasModalElement>("cas-modal")
);
export const ModalTemplate = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasModalTemplate, HTMLCasModalTemplateElement>(
    "cas-modal-template"
  )
);
export const ModalTrigger = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasModalTrigger, HTMLCasModalTriggerElement>(
    "cas-modal-trigger"
  )
);
export const Option = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasOption, HTMLCasOptionElement>("cas-option")
);
export const OptionsGroup = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasOptionsGroup, HTMLCasOptionsGroupElement>(
    "cas-options-group"
  )
);
export const Select = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasSelectV2, HTMLCasSelectV2Element>("cas-select-v2")
);
export const TabMenu = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasTabMenu, HTMLCasTabMenuElement>("cas-tab-menu")
);
export const TabBar = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasTabBar, HTMLCasTabBarElement>("cas-tab-bar")
);
export const Tab = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasTab, HTMLCasTabElement>("cas-tab")
);
export const TabContent = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasTabContent, HTMLCasTabContentElement>(
    "cas-tab-content"
  )
);
export const TabPanel = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasTabPanel, HTMLCasTabPanelElement>("cas-tab-panel")
);
export const UploadInput = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasUploadInput, HTMLCasUploadInputElement>(
    "cas-upload-input"
  )
);
export const Avatar = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasAvatar, HTMLCasAvatarElement>("cas-avatar")
);
export const AccordionItem = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasAccordionItem, HTMLCasAccordionItemElement>(
    "cas-accordion-item"
  )
);
export const TopBar = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasTopBar, HTMLCasTopBarElement>("cas-top-bar")
);
export const Tooltip = /*@__PURE__*/ memo(
  createReactComponent<JSX.CasTooltip, HTMLCasTooltipElement>("cas-tooltip")
);
